var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admins-details content"},[(_vm.admin)?_c('EditForm',{attrs:{"admin":_vm.admin}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }